module.exports = __webpack_public_path__ + "img/emmm.147b7c99.gif";